import { BaseModel } from "models/BaseModel";
import { TenantTypeFields, TenantTypeProps } from "./types";

export class TenantType extends BaseModel {
	[TenantTypeFields.ID]: string;
	[TenantTypeFields.NAME]: string;
	[TenantTypeFields.DESCRIPTION]: string;

	constructor(data: TenantTypeProps) {
		super(data);

		this[TenantTypeFields.ID] = data[TenantTypeFields.ID];
		this[TenantTypeFields.NAME] = data[TenantTypeFields.NAME];
		this[TenantTypeFields.DESCRIPTION] = data[TenantTypeFields.DESCRIPTION];
	}
}
